import React from 'react';
import { useSelector } from 'react-redux';
import './GlobalLoader.css';

const GlobalLoader = () => {
    const isGlobalLoading = useSelector((state) => state.applications?.globalLoading || false);
    const fetchLoading = useSelector((state) => state.applications?.fetchLoading || false);
    const applicationLoading = useSelector((state) => state.applications?.applicationLoading || false);

    // Show loader if any loading state is true
    const showLoader = isGlobalLoading || fetchLoading || applicationLoading;

    if (!showLoader) {
        return null;
    }

    return (
        <div className="global-loader-overlay">
            <div className="global-loader-content">
                <div className="spinner"></div>
                {/* <p className="global-loader-text">Loading...</p> */}
            </div>
        </div>
    );
};

export default GlobalLoader;

